import * as service from './service'
export default {
  namespace: 'PenaltyRecord',
  state: {
    recordListData: {}
  },
  effects: {
    * getRecordList ({ payload }, { call, put }) {
      const res = yield call(service.getRecordList, payload)
      yield put({
        type: 'save',
        payload: {
          recordListData: res.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
